if (!customElements.get('recommendations-load-more')) {
  class RecommendationsLoadMore extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-recommendations-load-more]');
      this.grid = this.querySelector('[data-recommendations-grid]');
      this.status = this.querySelector('[data-recommendations-status]');
    }

    connectedCallback() {
      if (!this.button || !this.grid) return;
      this.button.addEventListener('click', this.loadNextPage.bind(this));
    }

    async loadNextPage() {
      const nextPage = this.dataset.nextPage;
      if (!nextPage || this.hasAttribute('loading')) return;

      this.setAttribute('loading', '');
      this.button.disabled = true;

      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('page', nextPage);

      try {
        const response = await fetch(url.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = documentFragment.querySelector('recommendations-load-more');
        const nextGrid = nextSection && nextSection.querySelector('[data-recommendations-grid]');
        const products = nextGrid ? Array.from(nextGrid.children) : [];

        if (!nextSection || products.length === 0) {
          this.finishLoading();
          return;
        }

        const fragment = document.createDocumentFragment();
        products.forEach((product) => fragment.appendChild(product));
        this.grid.appendChild(fragment);
        this.dataset.currentPage = nextPage;
        this.dataset.nextPage = nextSection.dataset.nextPage || '';
        this.refreshScrollLayout();

        if (this.status) {
          this.status.textContent = `${products.length} more products loaded.`;
        }

        if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') {
          window.StampedFn.loadBadges();
        }

        if (!this.dataset.nextPage) this.finishLoading();
      } catch (error) {
        this.removeAttribute('loading');
        this.button.disabled = false;
        if (this.status) this.status.textContent = 'Products could not be loaded. Please try again.';
        console.error('Recommendations load more:', error);
      } finally {
        if (this.dataset.nextPage) {
          this.removeAttribute('loading');
          this.button.disabled = false;
        }
      }
    }

    finishLoading() {
      this.dataset.nextPage = '';
      this.removeAttribute('loading');
      if (this.button) this.button.closest('.recommendations-load-more__footer').remove();
      this.refreshScrollLayout();
    }

    refreshScrollLayout() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
          if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
            window.ScrollTrigger.refresh(true);
          }
        });
      });
    }
  }

  customElements.define('recommendations-load-more', RecommendationsLoadMore);
}
